import _typeof from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/svg/arrow-up-down.svg';
import _imports_1 from '@/assets/images/svg/cash-drawer.svg';
import _imports_2 from '@/assets/images/svg/file-spreadsheet.svg';
import _imports_3 from '@/assets/images/svg/banknote.svg';
import _imports_4 from '@/assets/images/svg/chevron-up-black.svg';
import _imports_5 from '@/assets/images/svg/file-spreadsheet-blue.svg';
import _imports_6 from '@/assets/images/svg/notebook-pen-red.svg';
import _imports_7 from '@/assets/images/svg/notebook-pen.svg';
import _imports_8 from '@/assets/images/svg/alert-triangle.svg';
import _imports_9 from '@/assets/images/svg/circle-x.svg';
import _imports_10 from '@/assets/images/svg/check-check.svg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-20579882"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "online-cashfloat-closure",
  "data-cy": "online-cashfloat-closure"
};
var _hoisted_2 = {
  class: "main-content"
};
var _hoisted_3 = {
  class: "d-flex fl-s-b fl-a-c"
};
var _hoisted_4 = {
  class: "title-container"
};
var _hoisted_5 = {
  class: "d-flex fl-s-b fl-a-c"
};
var _hoisted_6 = {
  class: "title"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "Watch video", -1);
});

var _hoisted_8 = {
  class: "session-info"
};
var _hoisted_9 = {
  class: "action-buttons"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Transfer",
    class: "btn-icon"
  }, null, -1);
});

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Cash",
    class: "btn-icon"
  }, null, -1);
});

var _hoisted_12 = {
  class: "tabs"
};
var _hoisted_13 = {
  key: 0,
  class: "loading-container",
  "data-cy": "loading-indicator"
};
var _hoisted_14 = {
  key: 1,
  class: "content-row"
};
var _hoisted_15 = {
  class: "panel-header"
};
var _hoisted_16 = {
  class: "panel-title large-title"
};

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Document",
    class: "panel-icon"
  }, null, -1);
});

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "View",
    class: "btn-icon"
  }, null, -1);
});

var _hoisted_19 = {
  key: 0,
  class: "details-list"
};
var _hoisted_20 = {
  class: "detail-item"
};
var _hoisted_21 = {
  class: "detail-label"
};
var _hoisted_22 = {
  class: "detail-value payments-amount"
};
var _hoisted_23 = {
  class: "detail-item"
};
var _hoisted_24 = {
  class: "detail-label"
};
var _hoisted_25 = {
  class: "detail-value refunds-amount"
};
var _hoisted_26 = {
  class: "detail-item"
};
var _hoisted_27 = {
  class: "detail-label"
};
var _hoisted_28 = {
  class: "detail-value change-amount"
};
var _hoisted_29 = {
  class: "detail-item"
};
var _hoisted_30 = {
  class: "detail-value"
};
var _hoisted_31 = {
  class: "detail-value settlement-amount"
};
var _hoisted_32 = {
  class: "detail-item mt-10"
};
var _hoisted_33 = {
  class: "detail-label"
};
var _hoisted_34 = {
  class: "detail-value initial-amount"
};
var _hoisted_35 = {
  class: "detail-item"
};
var _hoisted_36 = {
  class: "detail-label"
};
var _hoisted_37 = {
  class: "detail-value settlement-amount"
};
var _hoisted_38 = {
  key: 0,
  class: "detail-item"
};
var _hoisted_39 = {
  class: "detail-label"
};
var _hoisted_40 = {
  class: "detail-value transfer-in"
};
var _hoisted_41 = {
  key: 1,
  class: "detail-item"
};
var _hoisted_42 = {
  class: "detail-label"
};
var _hoisted_43 = {
  class: "detail-value transfer-out"
};
var _hoisted_44 = {
  class: "detail-item mt-10"
};
var _hoisted_45 = {
  class: "detail-value"
};
var _hoisted_46 = {
  class: "detail-value expected-amount"
};
var _hoisted_47 = {
  class: "detail-item"
};
var _hoisted_48 = {
  class: "detail-value"
};
var _hoisted_49 = {
  class: "detail-value counted-amount"
};
var _hoisted_50 = {
  class: "detail-item"
};
var _hoisted_51 = {
  class: "detail-item"
};
var _hoisted_52 = {
  class: "detail-label"
};
var _hoisted_53 = {
  class: "detail-value note"
};
var _hoisted_54 = {
  key: 1,
  class: "details-list"
};
var _hoisted_55 = {
  class: "detail-item"
};
var _hoisted_56 = {
  class: "detail-label"
};
var _hoisted_57 = {
  class: "detail-value initial-amount"
};
var _hoisted_58 = {
  class: "detail-item"
};
var _hoisted_59 = {
  class: "detail-label"
};
var _hoisted_60 = {
  class: "detail-value payments-amount"
};
var _hoisted_61 = {
  class: "detail-item"
};
var _hoisted_62 = {
  class: "detail-label"
};
var _hoisted_63 = {
  class: "detail-value refunds-amount"
};
var _hoisted_64 = {
  class: "detail-item"
};
var _hoisted_65 = {
  class: "detail-label"
};
var _hoisted_66 = {
  class: "detail-value change-amount"
};
var _hoisted_67 = {
  class: "detail-item"
};
var _hoisted_68 = {
  class: "detail-label"
};
var _hoisted_69 = {
  class: "detail-value settlement-amount"
};
var _hoisted_70 = {
  key: 0,
  class: "detail-item"
};
var _hoisted_71 = {
  class: "detail-label"
};
var _hoisted_72 = {
  class: "detail-value transfer-in"
};
var _hoisted_73 = {
  key: 1,
  class: "detail-item"
};
var _hoisted_74 = {
  class: "detail-label"
};
var _hoisted_75 = {
  class: "detail-value transfer-out"
};
var _hoisted_76 = {
  class: "detail-item"
};
var _hoisted_77 = {
  class: "detail-value"
};
var _hoisted_78 = {
  class: "detail-value expected-amount"
};
var _hoisted_79 = {
  class: "detail-item"
};
var _hoisted_80 = {
  class: "detail-value"
};
var _hoisted_81 = {
  class: "detail-value counted-amount"
};
var _hoisted_82 = {
  class: "detail-item"
};
var _hoisted_83 = {
  class: "detail-item"
};
var _hoisted_84 = {
  class: "detail-label"
};
var _hoisted_85 = {
  class: "detail-value note"
};
var _hoisted_86 = ["id"];
var _hoisted_87 = {
  class: "panel-header with-badge"
};
var _hoisted_88 = {
  class: "panel-title"
};
var _hoisted_89 = {
  class: "currency-content"
};
var _hoisted_90 = {
  class: "currency-row"
};
var _hoisted_91 = {
  class: "w-50"
};
var _hoisted_92 = {
  class: "currency-label"
};
var _hoisted_93 = {
  class: "currency-value"
};
var _hoisted_94 = {
  class: "w-50"
};
var _hoisted_95 = {
  class: "currency-label"
};
var _hoisted_96 = {
  class: "currency-row"
};
var _hoisted_97 = {
  class: "currency-label"
};
var _hoisted_98 = {
  class: "amount-input-container"
};
var _hoisted_99 = ["onUpdate:modelValue", "onBlur"];
var _hoisted_100 = {
  class: "input-arrows"
};
var _hoisted_101 = ["onClick"];

var _hoisted_102 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "Up"
  }, null, -1);
});

var _hoisted_103 = [_hoisted_102];
var _hoisted_104 = ["onClick"];

var _hoisted_105 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "Down"
  }, null, -1);
});

var _hoisted_106 = [_hoisted_105];
var _hoisted_107 = {
  class: "action-buttons mt-4"
};
var _hoisted_108 = ["onClick"];
var _hoisted_109 = {
  key: 0,
  src: _imports_5,
  alt: "View",
  class: "btn-icon"
};
var _hoisted_110 = {
  key: 1,
  src: _imports_2,
  alt: "View",
  class: "btn-icon"
};
var _hoisted_111 = ["onClick"];
var _hoisted_112 = ["id"];
var _hoisted_113 = {
  key: 0,
  src: _imports_6,
  alt: "Note",
  class: "btn-icon"
};
var _hoisted_114 = {
  key: 1,
  src: _imports_7,
  alt: "Note",
  class: "btn-icon"
};
var _hoisted_115 = {
  key: 2,
  class: "digital-details-panel digital-methods",
  "data-cy": "digital-summary-panel"
};
var _hoisted_116 = {
  class: "panel-header"
};
var _hoisted_117 = {
  class: "panel-title"
};
var _hoisted_118 = {
  key: 0,
  class: "details-list"
};
var _hoisted_119 = {
  class: "detail-item border-bottom"
};
var _hoisted_120 = {
  class: "detail-value w-50"
};
var _hoisted_121 = {
  class: "w-50 d-flex fl-s-b fl-a-c"
};
var _hoisted_122 = {
  class: "detail-value"
};
var _hoisted_123 = {
  class: "detail-value"
};
var _hoisted_124 = {
  class: "detail-value"
};
var _hoisted_125 = {
  class: "detail-item border-bottom"
};
var _hoisted_126 = {
  class: "detail-value w-50"
};
var _hoisted_127 = {
  class: "w-50 d-flex fl-s-b fl-a-c"
};
var _hoisted_128 = {
  class: "detail-value font-weight-500",
  "data-cy": "credit-cards-payment"
};
var _hoisted_129 = {
  class: "detail-value font-weight-500",
  "data-cy": "credit-cards-refund"
};
var _hoisted_130 = {
  class: "detail-value font-weight-500",
  "data-cy": "credit-cards-settlement"
};
var _hoisted_131 = {
  class: "detail-item border-bottom"
};
var _hoisted_132 = {
  class: "detail-value w-50"
};
var _hoisted_133 = {
  class: "w-50 d-flex fl-s-b fl-a-c"
};
var _hoisted_134 = {
  class: "detail-value font-weight-500",
  "data-cy": "vouchers-payment"
};
var _hoisted_135 = {
  class: "detail-value font-weight-500",
  "data-cy": "vouchers-refund"
};
var _hoisted_136 = {
  class: "detail-value font-weight-500",
  "data-cy": "vouchers-settlement"
};
var _hoisted_137 = {
  class: "detail-item border-bottom"
};
var _hoisted_138 = {
  class: "detail-value w-50"
};
var _hoisted_139 = {
  class: "w-50 d-flex fl-s-b fl-a-c"
};
var _hoisted_140 = {
  class: "detail-value font-weight-500",
  "data-cy": "gift-cards-payment"
};
var _hoisted_141 = {
  class: "detail-value font-weight-500",
  "data-cy": "gift-cards-refund"
};
var _hoisted_142 = {
  class: "detail-value font-weight-500",
  "data-cy": "gift-cards-settlement"
};
var _hoisted_143 = {
  class: "detail-item"
};
var _hoisted_144 = {
  class: "detail-value w-50 green"
};
var _hoisted_145 = {
  class: "w-50 d-flex fl-s-b fl-a-c"
};
var _hoisted_146 = {
  class: "detail-value green",
  "data-cy": "digital-total-payment"
};
var _hoisted_147 = {
  class: "detail-value green",
  "data-cy": "digital-total-refund"
};
var _hoisted_148 = {
  class: "detail-value green",
  "data-cy": "digital-total-settlement"
};
var _hoisted_149 = {
  class: "w-100 d-flex j-s-b fl-a-s closure-footer"
};
var _hoisted_150 = {
  class: "warning-text"
};

var _hoisted_151 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: "Warning",
    class: "warning-icon"
  }, null, -1);
});

var _hoisted_152 = {
  class: "footer-buttons"
};
var _hoisted_153 = ["disabled"];

var _hoisted_154 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    alt: "Cancel",
    class: "btn-icon"
  }, null, -1);
});

var _hoisted_155 = ["disabled"];

var _hoisted_156 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_10,
    alt: "Check",
    class: "btn-icon"
  }, null, -1);
});

var _hoisted_157 = {
  key: 1,
  style: {
    "width": "100%"
  },
  "data-cy": "add-note-modal"
};
var _hoisted_158 = {
  class: "dialog-footer"
};
var _hoisted_159 = {
  key: 2,
  class: "cash-inventory-modal"
};
var _hoisted_160 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-self": "center"
  },
  "data-cy": "cash-inventory-modal"
};
var _hoisted_161 = {
  style: {
    "font-size": "35px"
  }
};
var _hoisted_162 = {
  style: {
    "margin-top": "2%",
    "margin-bottom": "2%",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center"
  }
};
var _hoisted_163 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "border-bottom": "2px solid #ededed",
    "color": "#a6a6a6"
  }
};
var _hoisted_164 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_165 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_166 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};
var _hoisted_167 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_168 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_169 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};

var _hoisted_170 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("hr", null, null, -1);
});

var _hoisted_171 = {
  style: {
    "margin-top": "3%",
    "margin-bottom": "2%",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center"
  }
};
var _hoisted_172 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "border-bottom": "2px solid #ededed",
    "color": "#a6a6a6"
  }
};
var _hoisted_173 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_174 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_175 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};
var _hoisted_176 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_177 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_178 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};
var _hoisted_179 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_180 = {
  style: {
    "color": "#ededed"
  }
};
var _hoisted_181 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_182 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};
var _hoisted_183 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "padding-top": "1.5%",
    "padding-bottom": "2.5%"
  }
};
var _hoisted_184 = {
  class: "f-medium"
};
var _hoisted_185 = {
  class: "font-weight-700"
};
var _hoisted_186 = {
  class: "font-weight-700"
};
var _hoisted_187 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "flex-end",
    "border-top": "1px solid gray",
    "margin-top": "3%",
    "padding-top": "1.5%"
  }
};
var _hoisted_188 = {
  key: 3,
  class: "cash-destination-modal-wrapper"
};
var _hoisted_189 = {
  class: "cdm-container",
  "data-cy": "cash-destination-modal"
};
var _hoisted_190 = {
  class: "cdm-header"
};
var _hoisted_191 = {
  class: "cdm-title"
};
var _hoisted_192 = {
  class: "cdm-body"
};
var _hoisted_193 = {
  class: "cdm-form-group"
};
var _hoisted_194 = {
  class: "cdm-label",
  for: "destination-select"
};
var _hoisted_195 = ["disabled"];
var _hoisted_196 = {
  value: null,
  disabled: ""
};
var _hoisted_197 = ["value"];
var _hoisted_198 = {
  class: "cdm-checkbox-group"
};
var _hoisted_199 = {
  class: "cdm-footer"
};
var _hoisted_200 = {
  key: 4,
  class: "youtube-demo-modal-wrapper"
};

var _hoisted_201 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "cdm-container"
  }, [/*#__PURE__*/_createElementVNode("iframe", {
    src: "https://www.youtube.com/embed/OKWcmlHnhBc?si=JSNU3fRW1ENLT_ID",
    title: "YouTube video player",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    referrerpolicy: "strict-origin-when-cross-origin",
    allowfullscreen: ""
  })], -1);
});

var _hoisted_202 = [_hoisted_201];
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import CashFloatModule from "@/store/modules/cash-float";
import { LogService } from "@/services/logging";
import { allDetailedCurrencies } from "@/constants/currency";
import { formatDateTime } from "@/utils/helpers/dates";
import { ModalStatus } from "@/constants/modal";
import ModalModule from "@/store/modules/modal";
import { getManualClosingSummary, getDigitalClosingSummary, pushSyncCashfloat } from "@/api/cash-float/cash-float";
import { getCurrencySymbol } from "@/utils/vue-helpers/accounting";
import { PaymentMethods } from "@/types/db/accounting";
import POSConfigModule from "@/store/modules/pos-config";
import { printClosingSummaryReceipt } from "@/printing/handlers/receipts";
import { getGroupInfo } from "@/utils/vue-helpers/group";
import dayjs from "dayjs";
import { printCommonReceipt } from "@/utils/helpers/cross-platform";
import UserModule from "@/store/modules/user";
import { cloneDeep } from "lodash";
import NotificationService from "@/services/notification.service";
import DeviceModule from "@/store/modules/device";
import EURIcon from "@/assets/images/svg/currencies/euro.svg";
import CHFIcon from "@/assets/images/svg/currencies/chf.svg";
import USDIcon from "@/assets/images/svg/currencies/usd.svg";
import GBPIcon from "@/assets/images/svg/currencies/gbp.svg";
import YoutubeIcon from "@/assets/images/svg/youtube.svg";
import BookingModule from "@/store/modules/booking";
import { hasNonEmptyBookings } from "@/utils/vue-helpers/booking";
import { confirmClosingSales, handleCashTransferSync } from "@/utils/vue-helpers/cash-float";
import { generateID } from "@/utils/helpers/app";
import { clearDexieDB } from "@/utils/vue-helpers/db";
export default /*#__PURE__*/_defineComponent({
  __name: 'CloseCashfloat',
  setup: function setup(__props) {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var showSyncModal = ref(true);

    function handleSyncSuccess(_x) {
      return _handleSyncSuccess.apply(this, arguments);
    }

    function _handleSyncSuccess() {
      _handleSyncSuccess = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(status) {
        var _cashfloat$value6;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!status) {
                  // sync failed, notify the user and close
                  cancelAndReturn();
                }

                showSyncModal.value = false;
                _context5.prev = 2;
                isLoading.value = true;
                _context5.next = 6;
                return Promise.all([fetchManualSummary(), fetchDigitalSummary()]);

              case 6:
                _context5.next = 13;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](2);
                LogService.info("Sale closure: Error fetching closing summary for cash float uuid: ".concat((_cashfloat$value6 = cashfloat.value) === null || _cashfloat$value6 === void 0 ? void 0 : _cashfloat$value6.uid), {
                  error: _context5.t0
                });
                NotificationService.showCustomMessage(t("error.load-cashfloat"), "error");
                cancelAndReturn();

              case 13:
                _context5.prev = 13;
                isLoading.value = false;
                return _context5.finish(13);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 8, 13, 16]]);
      }));
      return _handleSyncSuccess.apply(this, arguments);
    }

    var hasLocation = computed(function () {
      // If there is no hardware location (machine not linked to a location or user using a browser) we don't show device settings
      if (!DeviceModule.hardwareLocation || !DeviceModule.hardwareLocation.locationId) {
        return false;
      } else {
        return true;
      }
    });
    var activeTab = ref("manual");
    var isLoading = ref(true);
    var isSubmitting = ref(false);
    var manualSummary = ref(null);
    var digitalSummary = ref(null);
    var cashfloat = ref(CashFloatModule.cashFloat);
    var selectedPayment = ref(null);
    var selectedCurrency = ref("CHF");
    var activeCurrencies = ref([]);
    var groupCurrencies = computed(function () {
      return POSConfigModule.groupCurrencies;
    });
    var groupCurrency = computed(function () {
      var currency = groupCurrencies.value.find(function (c) {
        return c.isDefault === 1;
      }) || groupCurrencies.value[0];
      return currency.label;
    });
    var openedByName = computed(function () {
      var _manualSummary$value;

      if ((_manualSummary$value = manualSummary.value) !== null && _manualSummary$value !== void 0 && _manualSummary$value.openedBy) {
        var _manualSummary$value$ = manualSummary.value.openedBy,
            firstName = _manualSummary$value$.firstName,
            lastName = _manualSummary$value$.lastName;
        return "".concat(firstName, " ").concat(lastName);
      }

      return "";
    });
    var sessionStartDate = computed(function () {
      var _manualSummary$value2, _cashfloat$value;

      if ((_manualSummary$value2 = manualSummary.value) !== null && _manualSummary$value2 !== void 0 && _manualSummary$value2.createdAt) {
        return formatDateTime(manualSummary.value.createdAt);
      }

      return formatDateTime(((_cashfloat$value = cashfloat.value) === null || _cashfloat$value === void 0 ? void 0 : _cashfloat$value.createdAt) || "");
    });
    var sessionOpenedMessagee = computed(function () {
      return t("cashfloat.session-opened-message", {
        datetime: sessionStartDate.value,
        user: openedByName.value
      });
    });
    var showNoteDialog = ref(false);
    var note = ref("");
    var selectedPaymentForNote = ref(null);
    var selectedCurrencyForNote = ref(null); // a map of counted amounts per currency per payment method

    var forMattedCountedAmounts = ref({});
    var currencyPanels = ref(null);
    var showCashInventoryDialog = ref(false);
    var cashDetailsArea = ref(null);
    var detailedActiveCurrencies = [];
    var selectedDetailedCurrency = ref(null);
    var locationsList = computed(function () {
      return DeviceModule.locations.filter(function (l) {
        var _DeviceModule$hardwar;

        return l.id !== Number((_DeviceModule$hardwar = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar === void 0 ? void 0 : _DeviceModule$hardwar.locationId);
      });
    });
    var showCashDestinationModal = ref(false);
    var willMoneyStayInDrawer = ref(false);
    var selectedDestinationLocationId = ref(null);
    var showYoutubeDemo = ref(false);

    function toggleYoutubeDemoModal(show) {
      showYoutubeDemo.value = show;
      LogService.info("Sale closure: User ".concat(show ? "opened" : "closed", " the youtube demo"));
    }

    function resetSelectedDestination() {
      selectedDestinationLocationId.value = null;
    }

    function closeCashDestinationModal() {
      showCashDestinationModal.value = false;
    }

    function openCashInventory(currency) {
      // try to find it in detailedActiveCurrencies
      // if not found, find it in allDetailedCurrencies and clone it
      var existingDetailedCurrency = detailedActiveCurrencies.find(function (c) {
        return c.id === currency;
      });
      var detailedCurrency = existingDetailedCurrency || allDetailedCurrencies.find(function (c) {
        return c.id === currency;
      });

      if (!detailedCurrency) {
        LogService.info("Sale closure: Detailed currency not found for ".concat(currency));
        return;
      }

      selectedDetailedCurrency.value = cloneDeep(detailedCurrency);
      showCashInventoryDialog.value = true;
    }

    function confirmCashInventory() {
      if (!selectedDetailedCurrency.value || !selectedPayment.value || !selectedCurrency.value) {
        return;
      } // add or replace it into detailedActiveCurrencies


      var index = detailedActiveCurrencies.findIndex(function (c) {
        var _selectedDetailedCurr;

        return c.id === ((_selectedDetailedCurr = selectedDetailedCurrency.value) === null || _selectedDetailedCurr === void 0 ? void 0 : _selectedDetailedCurr.id);
      });

      if (index !== -1) {
        detailedActiveCurrencies[index] = selectedDetailedCurrency.value;
      } else {
        detailedActiveCurrencies.push(selectedDetailedCurrency.value);
      } // calculate counted amount


      var newCountedAmoumt = sumDetailedCurrency(selectedDetailedCurrency.value); // update counted amount

      if (!selectedPayment.value.countedAmounts) {
        selectedPayment.value.countedAmounts = {};
      }

      selectedPayment.value.countedAmounts[selectedCurrency.value] = newCountedAmoumt;
      forMattedCountedAmounts.value[selectedPayment.value.name][selectedCurrency.value] = (newCountedAmoumt / 100).toFixed(2);
      showCashInventoryDialog.value = false;
    }

    function cancelCashInventory() {
      // reset selected detailed currency
      selectedDetailedCurrency.value = null;
      showCashInventoryDialog.value = false;
    }

    function sumDetailedCurrency(detailedCurrency) {
      var sum = 0; // Bills: convert to cents (multiply by 100)

      for (var i = 0; i < detailedCurrency.bills.length; i++) {
        sum = sum + Number(detailedCurrency.bills[i].name) * Number(detailedCurrency.bills[i].userInput) * 100;
      } // Coins: convert to cents (multiply by 100)


      for (var _i = 0; _i < detailedCurrency.coins.length; _i++) {
        sum = sum + Number(detailedCurrency.coins[_i].name) * Number(detailedCurrency.coins[_i].userInput) * 100;
      } // Cents: already in cents, no conversion needed


      for (var _i2 = 0; _i2 < detailedCurrency.cents.length; _i2++) {
        sum = sum + Number(detailedCurrency.cents[_i2].name) * Number(detailedCurrency.cents[_i2].userInput);
      } // Round to nearest cent to avoid floating point errors


      return Math.round(sum);
    }

    function scrollToTopCashInventory() {
      var _cashDetailsArea$valu;

      (_cashDetailsArea$valu = cashDetailsArea.value) === null || _cashDetailsArea$valu === void 0 ? void 0 : _cashDetailsArea$valu.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }

    function scrollToCurrencySection(paymentMethodSummary, currency) {
      var sectionId = "currency-section-".concat(paymentMethodSummary.name, "-").concat(currency);
      var target = document.getElementById(sectionId);

      if (currencyPanels.value && target) {
        var container = currencyPanels.value;
        var containerTop = container.getBoundingClientRect().top;
        var targetTop = target.getBoundingClientRect().top;
        var scrollOffset = targetTop - containerTop + container.scrollTop;
        container.scrollTo({
          top: scrollOffset,
          behavior: "smooth"
        });
      }
    }

    function shakeNoteContent(paymentMethodSummary, currency) {
      var el = document.getElementById("note-content-".concat(paymentMethodSummary.name, "-").concat(currency));

      if (el) {
        el.classList.remove("shake"); // reset animation

        void el.offsetWidth; // force reflow

        el.classList.add("shake");
      }
    }

    function openNoteDialog(paymentMethodSummary, currency) {
      var _paymentMethodSummary;

      note.value = ((_paymentMethodSummary = paymentMethodSummary.notes) === null || _paymentMethodSummary === void 0 ? void 0 : _paymentMethodSummary[currency]) || "";
      selectedPaymentForNote.value = paymentMethodSummary;
      selectedCurrencyForNote.value = currency;
      showNoteDialog.value = true;
    }

    function addNote(paymentMethodSummary, currency) {
      if (!paymentMethodSummary.notes) {
        paymentMethodSummary.notes = {};
      }

      paymentMethodSummary.notes[currency] = note.value;
      showNoteDialog.value = false;
      note.value = "";
      selectedPaymentForNote.value = null;
      selectedCurrencyForNote.value = null;
    }

    function getNote(paymentMethodSummary, currency) {
      var _paymentMethodSummary2;

      return ((_paymentMethodSummary2 = paymentMethodSummary.notes) === null || _paymentMethodSummary2 === void 0 ? void 0 : _paymentMethodSummary2[currency]) || "";
    }

    function formatCurrencyWithSymbol(amount, currency) {
      if (!amount) return "".concat(getCurrencySymbol(currency), " 0.00");
      var formattedAmount = (amount / 100).toFixed(2);
      return "".concat(getCurrencySymbol(currency), " ").concat(formattedAmount);
    }

    function getInitialAmount(paymentMethodSummary, currency) {
      var _paymentMethodSummary3;

      // only for CASH payment method
      if (paymentMethodSummary.name !== PaymentMethods.METHOD_POS_CASH) {
        return 0;
      }

      var initialAmount = ((_paymentMethodSummary3 = paymentMethodSummary.startAmounts) === null || _paymentMethodSummary3 === void 0 ? void 0 : _paymentMethodSummary3[currency]) || 0;
      return initialAmount;
    }

    function getExpectedAmount(paymentMethodSummary, currency) {
      var _paymentMethodSummary4;

      var expected = ((_paymentMethodSummary4 = paymentMethodSummary.amounts) === null || _paymentMethodSummary4 === void 0 ? void 0 : _paymentMethodSummary4[currency]) || 0;
      return expected;
    }

    function getDifference(paymentMethodSummary, currency) {
      var _paymentMethodSummary5, _paymentMethodSummary6;

      var counted = ((_paymentMethodSummary5 = paymentMethodSummary.countedAmounts) === null || _paymentMethodSummary5 === void 0 ? void 0 : _paymentMethodSummary5[currency]) || 0;
      var expected = ((_paymentMethodSummary6 = paymentMethodSummary.amounts) === null || _paymentMethodSummary6 === void 0 ? void 0 : _paymentMethodSummary6[currency]) || 0;
      return counted - expected;
    }

    function getCountedAmount(paymentMethodSummary, currency) {
      var _paymentMethodSummary7;

      var counted = ((_paymentMethodSummary7 = paymentMethodSummary.countedAmounts) === null || _paymentMethodSummary7 === void 0 ? void 0 : _paymentMethodSummary7[currency]) || 0;
      return counted;
    }

    function getCustomerAmountIn(paymentMethodSummary, currency) {
      var _paymentMethodSummary8;

      var customerAmountIn = ((_paymentMethodSummary8 = paymentMethodSummary.cutomerAmountIn) === null || _paymentMethodSummary8 === void 0 ? void 0 : _paymentMethodSummary8[currency]) || 0;
      return customerAmountIn;
    }

    function getRefund(paymentMethodSummary, currency) {
      var _paymentMethodSummary9;

      var refund = ((_paymentMethodSummary9 = paymentMethodSummary.refund) === null || _paymentMethodSummary9 === void 0 ? void 0 : _paymentMethodSummary9[currency]) || 0;
      return refund;
    }

    function getChange(paymentMethodSummary, currency) {
      var _paymentMethodSummary10;

      // only for CASH payment method
      if (paymentMethodSummary.name !== PaymentMethods.METHOD_POS_CASH) {
        return 0;
      }

      var change = ((_paymentMethodSummary10 = paymentMethodSummary.change) === null || _paymentMethodSummary10 === void 0 ? void 0 : _paymentMethodSummary10[currency]) || 0;
      return change;
    }

    function getSettlement(paymentMethodSummary, currency) {
      var payment = getCustomerAmountIn(paymentMethodSummary, currency);
      var refund = getRefund(paymentMethodSummary, currency);
      var change = getChange(paymentMethodSummary, currency);
      return payment + refund + change;
    }

    function getTransferIn(paymentMethodSummary, currency) {
      var _paymentMethodSummary11;

      // only for CASH payment method
      if (paymentMethodSummary.name !== PaymentMethods.METHOD_POS_CASH) {
        return 0;
      }

      var transferIn = ((_paymentMethodSummary11 = paymentMethodSummary.transferIn) === null || _paymentMethodSummary11 === void 0 ? void 0 : _paymentMethodSummary11[currency]) || 0;
      return transferIn;
    }

    function getTransferOut(paymentMethodSummary, currency) {
      var _paymentMethodSummary12;

      // only for CASH payment method
      if (paymentMethodSummary.name !== PaymentMethods.METHOD_POS_CASH) {
        return 0;
      }

      var transferOut = ((_paymentMethodSummary12 = paymentMethodSummary.transferOut) === null || _paymentMethodSummary12 === void 0 ? void 0 : _paymentMethodSummary12[currency]) || 0;
      return transferOut;
    } // Methods for switching tabs and fetching data


    var switchTab = function switchTab(tab) {
      activeTab.value = tab;
    }; // Fetch summary data from API


    var fetchManualSummary = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _CashFloatModule$cash, cashfloatUuid, response, _CashFloatModule$cash2;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                cashfloatUuid = (_CashFloatModule$cash = CashFloatModule.cashFloat) === null || _CashFloatModule$cash === void 0 ? void 0 : _CashFloatModule$cash.uid;

                if (cashfloatUuid) {
                  _context.next = 5;
                  break;
                }

                LogService.info("Sale closure: No cashfloat UUID available");
                return _context.abrupt("return");

              case 5:
                _context.next = 7;
                return getManualClosingSummary(cashfloatUuid);

              case 7:
                response = _context.sent;
                manualSummary.value = response;
                LogService.info("Sale closure: Manual closing summary fetched for uuid: ".concat(cashfloatUuid), {
                  manualSummary: response
                }); // Update active currencies

                if (response.activeCurrencies) {
                  // make sure the main currency is first
                  response.activeCurrencies.sort(function (a, b) {
                    return a === groupCurrency.value ? -1 : 1;
                  });
                  activeCurrencies.value = response.activeCurrencies;
                } // Initialize counted amounts, notes, and settlement directly within manualSummary


                if (manualSummary.value.amountsPerPaymentMethods) {
                  response.amountsPerPaymentMethods.forEach(function (pm) {
                    pm.countedAmounts = pm.countedAmounts || {};
                    pm.notes = pm.notes || {};
                    pm.settlement = pm.settlement || {}; // Calculate and store settlement for each currency

                    var _iterator = _createForOfIteratorHelper(response.activeCurrencies || []),
                        _step;

                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var _pm$cutomerAmountIn, _pm$refund, _pm$change;

                        var currency = _step.value;
                        var payment = ((_pm$cutomerAmountIn = pm.cutomerAmountIn) === null || _pm$cutomerAmountIn === void 0 ? void 0 : _pm$cutomerAmountIn[currency]) || 0;
                        var refund = ((_pm$refund = pm.refund) === null || _pm$refund === void 0 ? void 0 : _pm$refund[currency]) || 0;
                        var change = ((_pm$change = pm.change) === null || _pm$change === void 0 ? void 0 : _pm$change[currency]) || 0;
                        pm.settlement[currency] = payment + refund + change;
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }

                    forMattedCountedAmounts.value[pm.name] = {};
                    activeCurrencies.value.forEach(function (currency) {
                      var _pm$amounts;

                      var expectedAmountValue = ((_pm$amounts = pm.amounts) === null || _pm$amounts === void 0 ? void 0 : _pm$amounts[currency]) || 0; // Initialize counted amount to expected if not already set (e.g., from user input)

                      if (pm.countedAmounts && pm.countedAmounts[currency] === undefined) {
                        pm.countedAmounts[currency] = expectedAmountValue || 0;
                      } // Initialize notes if not already set


                      if (pm.notes && pm.notes[currency] === undefined) {
                        pm.notes[currency] = "";
                      } // Initialize formatted counted amounts


                      forMattedCountedAmounts.value[pm.name][currency] = (expectedAmountValue / 100).toFixed(2);
                    });
                  });
                } // set selected payment method to the first one


                if (manualSummary.value.amountsPerPaymentMethods.length > 0) {
                  selectedPayment.value = manualSummary.value.amountsPerPaymentMethods[0];
                }

                if (activeCurrencies.value.length > 0) {
                  // set selected currency to the first one
                  selectedCurrency.value = activeCurrencies.value[0];
                }

                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);
                LogService.info("Sale closure: Error fetching manual closing summary for uuid: ".concat((_CashFloatModule$cash2 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash2 === void 0 ? void 0 : _CashFloatModule$cash2.uid), {
                  error: _context.t0
                });
                throw _context.t0;

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 16]]);
      }));

      return function fetchManualSummary() {
        return _ref.apply(this, arguments);
      };
    }();

    var fetchDigitalSummary = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _cashfloat$value2, cashfloatUuid, response, _cashfloat$value3;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                cashfloatUuid = (_cashfloat$value2 = cashfloat.value) === null || _cashfloat$value2 === void 0 ? void 0 : _cashfloat$value2.uid;

                if (cashfloatUuid) {
                  _context2.next = 5;
                  break;
                }

                LogService.info("Sale closure: No cashfloat UUID available");
                return _context2.abrupt("return");

              case 5:
                _context2.next = 7;
                return getDigitalClosingSummary(cashfloatUuid);

              case 7:
                response = _context2.sent;
                digitalSummary.value = response; // Calculate and store settlement for digital payment methods

                if (digitalSummary.value) {
                  digitalSummary.value.totalCreditCard.settlement = digitalSummary.value.totalCreditCard.payment + digitalSummary.value.totalCreditCard.refund;
                  digitalSummary.value.totalVoucher.settlement = digitalSummary.value.totalVoucher.payment + digitalSummary.value.totalVoucher.refund;
                  digitalSummary.value.totalGiftCard.settlement = digitalSummary.value.totalGiftCard.payment + digitalSummary.value.totalGiftCard.refund;
                  digitalSummary.value.total.settlement = digitalSummary.value.total.payment + digitalSummary.value.total.refund;
                }

                LogService.info("Sale closure: Digital closing summary fetched for uuid: ".concat(cashfloatUuid), {
                  digitalSummary: response
                });
                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                LogService.info("Sale closure: Error fetching digital closing summary for uuid: ".concat((_cashfloat$value3 = cashfloat.value) === null || _cashfloat$value3 === void 0 ? void 0 : _cashfloat$value3.uid), {
                  error: _context2.t0
                });
                throw _context2.t0;

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 13]]);
      }));

      return function fetchDigitalSummary() {
        return _ref2.apply(this, arguments);
      };
    }(); // Action handlers


    var addCashTransfer = function addCashTransfer() {
      LogService.info("Sale closure: Opening cash transfer modal");
      ModalModule.setStatus(ModalStatus.CashInOut);
    };

    var openCashDrawer = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                LogService.info("Sale closure: Opening cash drawer");

                try {
                  printCommonReceipt("");
                } catch (error) {
                  LogService.info("Sale closure: Error opening cash drawer", {
                    error: error
                  });
                }

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function openCashDrawer() {
        return _ref3.apply(this, arguments);
      };
    }();

    var cancelAndReturn = function cancelAndReturn() {
      var _cashfloat$value4;

      LogService.info("Sale closure: Canceling cash float close, uuid: ".concat((_cashfloat$value4 = cashfloat.value) === null || _cashfloat$value4 === void 0 ? void 0 : _cashfloat$value4.uid));
      CashFloatModule.setShowClosingSummary(false);
      CashFloatModule.setIsClosingCashfloat(false);
    };

    var acceptAndClose = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var closingConfirmed, _cashfloat$value5, cashfloatUuid, _iterator2, _step2, _loop, _ret, cashPaymentSummary, difference, isGain, from, to, _DeviceModule$hardwar2, _DeviceModule$hardwar3, _DeviceModule$hardwar4, _DeviceModule$hardwar5, cashTransferOut, isSynced, isCashfloatCashedOut, _DeviceModule$hardwar6, _DeviceModule$hardwar7, _from, _to, _cashTransferOut, _isSynced, closingAmounts, _iterator3, _step3, c, cashfloatInfo, _iterator4, _step4, pm, _iterator6, _step6, currency, cashfloatCopy, closingBillsAndCoinsByCurrency;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                isSubmitting.value = true;

                if (!hasNonEmptyBookings.value) {
                  _context4.next = 11;
                  break;
                }

                LogService.info("Sale closure: User closing cashfloat with incomplete/partially paid bookings, prompting for confirmation"); // if user has incomplete or partially paid bookings, a warning is shown

                _context4.next = 5;
                return confirmClosingSales();

              case 5:
                closingConfirmed = _context4.sent;

                if (closingConfirmed) {
                  _context4.next = 10;
                  break;
                }

                LogService.info("Sale closure: User canceled closing sales");
                isSubmitting.value = false;
                return _context4.abrupt("return");

              case 10:
                LogService.info("Sale closure: User confirmed closing sales");

              case 11:
                if (!(!cashfloat.value || !cashfloat.value.uid || !manualSummary.value)) {
                  _context4.next = 16;
                  break;
                }

                LogService.info("Sale closure: Cash float or summary data is missing when closing, uuid: ".concat((_cashfloat$value5 = cashfloat.value) === null || _cashfloat$value5 === void 0 ? void 0 : _cashfloat$value5.uid), {
                  cashfloat: cashfloat.value,
                  manualSummary: manualSummary.value
                });
                NotificationService.showCustomMessage("Cash float or summary data is missing", "error");
                isSubmitting.value = false;
                return _context4.abrupt("return");

              case 16:
                cashfloatUuid = cashfloat.value.uid; // Check if there are any differences that need to have a note
                // if we have a difference without a note, we scroll to the first one

                _iterator2 = _createForOfIteratorHelper(manualSummary.value.amountsPerPaymentMethods);
                _context4.prev = 18;

                _loop = function _loop() {
                  var pm = _step2.value;

                  var _iterator5 = _createForOfIteratorHelper(activeCurrencies.value),
                      _step5;

                  try {
                    var _loop2 = function _loop2() {
                      var currency = _step5.value;

                      if (getDifference(pm, currency) && !getNote(pm, currency)) {
                        scrollToCurrencySection(pm, currency); // wait a bit and shake the note icon

                        setTimeout(function () {
                          shakeNoteContent(pm, currency);
                        }, 500);
                        isSubmitting.value = false;
                        return {
                          v: {
                            v: void 0
                          }
                        };
                      }
                    };

                    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                      var _ret2 = _loop2();

                      if (_typeof(_ret2) === "object") return _ret2.v;
                    }
                  } catch (err) {
                    _iterator5.e(err);
                  } finally {
                    _iterator5.f();
                  }
                };

                _iterator2.s();

              case 21:
                if ((_step2 = _iterator2.n()).done) {
                  _context4.next = 27;
                  break;
                }

                _ret = _loop();

                if (!(_typeof(_ret) === "object")) {
                  _context4.next = 25;
                  break;
                }

                return _context4.abrupt("return", _ret.v);

              case 25:
                _context4.next = 21;
                break;

              case 27:
                _context4.next = 32;
                break;

              case 29:
                _context4.prev = 29;
                _context4.t0 = _context4["catch"](18);

                _iterator2.e(_context4.t0);

              case 32:
                _context4.prev = 32;

                _iterator2.f();

                return _context4.finish(32);

              case 35:
                if (!(hasLocation.value && !willMoneyStayInDrawer.value && !selectedDestinationLocationId.value)) {
                  _context4.next = 39;
                  break;
                }

                showCashDestinationModal.value = true;
                isSubmitting.value = false;
                return _context4.abrupt("return");

              case 39:
                // for cashbook logic, if we have a difference in cash (counted vs expected), we need to justify it via a Gain/Loss cash transfer
                // cashbook logic is only for the main group currency (for now)
                cashPaymentSummary = manualSummary.value.amountsPerPaymentMethods.find(function (pm) {
                  return pm.name === PaymentMethods.METHOD_POS_CASH;
                });

                if (!(hasLocation.value && groupCurrency.value && cashPaymentSummary)) {
                  _context4.next = 72;
                  break;
                }

                difference = cashPaymentSummary ? getDifference(cashPaymentSummary, groupCurrency.value) : 0;

                if (!(difference !== 0)) {
                  _context4.next = 58;
                  break;
                }

                // so we have a difference that needs to be tracked via Gain/Loss cash transfer
                LogService.info("Sale closure: There is cash difference when closing the cashfloat: ".concat(cashfloatUuid, " as attached"), {
                  params: {
                    currency: groupCurrency.value,
                    expectedCashfloat: getExpectedAmount(cashPaymentSummary, groupCurrency.value),
                    finalManualCashfloat: getCountedAmount(cashPaymentSummary, groupCurrency.value)
                  }
                });
                isGain = difference > 0 ? true : false;
                from = null;
                to = null;

                if (isGain) {
                  // cashIn to the device because it is a gain
                  to = DeviceModule.hardwareLocation && (_DeviceModule$hardwar2 = DeviceModule.hardwareLocation) !== null && _DeviceModule$hardwar2 !== void 0 && _DeviceModule$hardwar2.locationId ? Number((_DeviceModule$hardwar3 = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar3 === void 0 ? void 0 : _DeviceModule$hardwar3.locationId) : null;
                  from = null;
                } else {
                  // cashOut from the device because it is a loss
                  from = DeviceModule.hardwareLocation && (_DeviceModule$hardwar4 = DeviceModule.hardwareLocation) !== null && _DeviceModule$hardwar4 !== void 0 && _DeviceModule$hardwar4.locationId ? Number((_DeviceModule$hardwar5 = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar5 === void 0 ? void 0 : _DeviceModule$hardwar5.locationId) : null;
                  to = null;
                }

                cashTransferOut = {
                  _id: dayjs().toISOString(),
                  createdAt: dayjs().toISOString(),
                  amount: Math.abs(difference / 100),
                  currency: groupCurrency.value,
                  groupId: Number(POSConfigModule.groupId),
                  from: from,
                  to: to,
                  note: getNote(cashPaymentSummary, groupCurrency.value) || null,
                  channel: "Smeetz POS",
                  uuid: generateID(),
                  isGainLoss: true
                };

                if (CashFloatModule.initialTransferDone) {
                  _context4.next = 58;
                  break;
                }

                LogService.info("Sale closure: Adding Gain/Loss cash transfer for cash difference when closing the cashfloat: ".concat(cashfloatUuid), {
                  cashTransfer: cashTransferOut
                });
                _context4.next = 53;
                return handleCashTransferSync(cashTransferOut);

              case 53:
                isSynced = _context4.sent;

                if (isSynced) {
                  _context4.next = 57;
                  break;
                }

                isSubmitting.value = false;
                return _context4.abrupt("return");

              case 57:
                /**
                 * Since next cash transfers (coming from user cashing out closing amount) can fail and user is asked to try again
                 * This gain/loss transfer can be generated more than once
                 * To resolve this, a flag is set to true when this transfer is done to not send it again
                 * This flag is reset after all cash transfers are done
                 */
                CashFloatModule.setInitialTransferDone(true);

              case 58:
                // User may want to cash out the full closing amount if his machine is linked
                isCashfloatCashedOut = false;

                if (!(!willMoneyStayInDrawer.value && selectedDestinationLocationId.value)) {
                  _context4.next = 71;
                  break;
                }

                LogService.info("Sale closure: User opted to cash out the closing amount for cashfloat: ".concat(cashfloatUuid));
                _from = DeviceModule.hardwareLocation && (_DeviceModule$hardwar6 = DeviceModule.hardwareLocation) !== null && _DeviceModule$hardwar6 !== void 0 && _DeviceModule$hardwar6.locationId ? Number((_DeviceModule$hardwar7 = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar7 === void 0 ? void 0 : _DeviceModule$hardwar7.locationId) : null;
                _to = selectedDestinationLocationId.value; // Add a new CashTransfer of type (OUT)

                _cashTransferOut = {
                  _id: dayjs().toISOString(),
                  createdAt: dayjs().toISOString(),
                  amount: Math.abs(getCountedAmount(cashPaymentSummary, groupCurrency.value) / 100),
                  currency: groupCurrency.value
                  /*Currencies.CHF*/
                  ,
                  groupId: Number(POSConfigModule.groupId),
                  from: _from,
                  to: _to,
                  note: "",
                  channel: "Smeetz POS",
                  uuid: generateID()
                };
                _context4.next = 66;
                return handleCashTransferSync(_cashTransferOut);

              case 66:
                _isSynced = _context4.sent;

                if (_isSynced) {
                  _context4.next = 70;
                  break;
                }

                isSubmitting.value = false;
                return _context4.abrupt("return");

              case 70:
                isCashfloatCashedOut = true;

              case 71:
                if (!isCashfloatCashedOut) {
                  // user didn't cash out the cash closing amount
                  // we need to keep this info, it will be used in the next cashfloat opening
                  closingAmounts = {}; // add amounts for all currencies (only for cash)

                  _iterator3 = _createForOfIteratorHelper(activeCurrencies.value);

                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      c = _step3.value;
                      closingAmounts[c] = getCountedAmount(cashPaymentSummary, c);
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }

                  cashfloatInfo = {
                    uuid: cashfloatUuid,
                    closingAmounts: closingAmounts,
                    isCashedOut: false
                  };
                  LogService.info("Sale closure: User didn't cash out cashfloat closing amount. Setting cashfloat info attached to previousCashfloat property in the state: ".concat(cashfloatUuid), {
                    params: {
                      previousCashfloat: cashfloatInfo
                    }
                  });
                  CashFloatModule.setPreviousCashFloat(cashfloatInfo);
                } else {
                  LogService.info("Sale closure: User cashed out full cashfloat closing amount. Setting null to previousCashfloat property in the state: ".concat(cashfloatUuid));
                  CashFloatModule.setPreviousCashFloat(null);
                }

              case 72:
                // check and log if there is at least 1 difference
                _iterator4 = _createForOfIteratorHelper(manualSummary.value.amountsPerPaymentMethods);
                _context4.prev = 73;

                _iterator4.s();

              case 75:
                if ((_step4 = _iterator4.n()).done) {
                  _context4.next = 97;
                  break;
                }

                pm = _step4.value;
                _iterator6 = _createForOfIteratorHelper(activeCurrencies.value);
                _context4.prev = 78;

                _iterator6.s();

              case 80:
                if ((_step6 = _iterator6.n()).done) {
                  _context4.next = 87;
                  break;
                }

                currency = _step6.value;

                if (!getDifference(pm, currency)) {
                  _context4.next = 85;
                  break;
                }

                LogService.info("Sale closure: There is a difference when closing the cashfloat: ".concat(cashfloatUuid));
                return _context4.abrupt("break", 87);

              case 85:
                _context4.next = 80;
                break;

              case 87:
                _context4.next = 92;
                break;

              case 89:
                _context4.prev = 89;
                _context4.t1 = _context4["catch"](78);

                _iterator6.e(_context4.t1);

              case 92:
                _context4.prev = 92;

                _iterator6.f();

                return _context4.finish(92);

              case 95:
                _context4.next = 75;
                break;

              case 97:
                _context4.next = 102;
                break;

              case 99:
                _context4.prev = 99;
                _context4.t2 = _context4["catch"](73);

                _iterator4.e(_context4.t2);

              case 102:
                _context4.prev = 102;

                _iterator4.f();

                return _context4.finish(102);

              case 105:
                _context4.prev = 105;
                // add closing summary to cash float
                cashfloatCopy = cloneDeep(cashfloat.value);
                cashfloatCopy.closingSummary = {
                  manualClosingSummary: manualSummary.value,
                  digitalClosingSummary: digitalSummary.value
                }; // add billsAndCoinsByCurrency details for closing if available

                if (detailedActiveCurrencies.length > 0) {
                  if (!cashfloatCopy.billsAndCoinsByCurrency) {
                    cashfloatCopy.billsAndCoinsByCurrency = {};
                  }

                  closingBillsAndCoinsByCurrency = [];
                  detailedActiveCurrencies.forEach(function (dc) {
                    closingBillsAndCoinsByCurrency.push({
                      currency: dc.id,
                      bills: dc.bills.map(function (b) {
                        return {
                          name: String(b.name),
                          userInput: b.userInput
                        };
                      }),
                      coins: dc.coins.map(function (c) {
                        return {
                          name: String(c.name),
                          userInput: c.userInput
                        };
                      }),
                      cents: dc.cents.map(function (c) {
                        return {
                          name: String(c.name),
                          userInput: c.userInput
                        };
                      })
                    });
                  });
                  cashfloatCopy.billsAndCoinsByCurrency.closing = closingBillsAndCoinsByCurrency;
                } // set closeDate


                cashfloatCopy.closeDate = dayjs().toISOString();
                CashFloatModule.setCashFloat(cashfloatCopy);
                LogService.info("Sale closure: Final closing summary shape before closing cash float uuid: ".concat(cashfloatUuid), {
                  cashfloat: cashfloatCopy
                }); // submit closing cash float

                LogService.info("Sale closure: Submitting closed cashfloat, uuid: ".concat(cashfloatUuid), {
                  cashfloat: cashfloatCopy
                });
                _context4.prev = 113;
                _context4.next = 116;
                return pushSyncCashfloat([cashfloatCopy]);

              case 116:
                _context4.next = 122;
                break;

              case 118:
                _context4.prev = 118;
                _context4.t3 = _context4["catch"](113);
                LogService.info("Sale closure: Error submitting closed cashfloat, uuid: ".concat(cashfloatUuid), {
                  cashfloat: cashfloatCopy,
                  error: _context4.t3
                });
                throw _context4.t3;

              case 122:
                prepareAndPrintReceipt(cashfloatCopy);
                CashFloatModule.setIsClosingCashfloat(false);
                CashFloatModule.setShowClosingSummary(false);
                CashFloatModule.setCashFloat(null); // Ensure that no booking is remaining when sales are closed

                BookingModule.clearAllBookings(); // clear Dexie db bookings

                _context4.next = 129;
                return clearDexieDB();

              case 129:
                _context4.next = 135;
                break;

              case 131:
                _context4.prev = 131;
                _context4.t4 = _context4["catch"](105);
                LogService.info("Sale closure: Error closing cash float: ".concat(cashfloatUuid), {
                  error: _context4.t4
                });
                NotificationService.showCustomMessage(t("error.close-cashfloat"), "error");

              case 135:
                _context4.prev = 135;
                isSubmitting.value = false;
                return _context4.finish(135);

              case 138:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[18, 29, 32, 35], [73, 99, 102, 105], [78, 89, 92, 95], [105, 131, 135, 138], [113, 118]]);
      }));

      return function acceptAndClose() {
        return _ref4.apply(this, arguments);
      };
    }();

    function prepareAndPrintReceipt(_x2) {
      return _prepareAndPrintReceipt.apply(this, arguments);
    }

    function _prepareAndPrintReceipt() {
      _prepareAndPrintReceipt = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(cashfloat) {
        var _manualSummary$value5, _manualSummary$value6, _manualSummary$value7, _manualSummary$value8;

        var seller, sellerName, groupInfo, paymentMethodSections, _iterator7, _step7, pm, _iterator10, _step10, _currency, section, _note2, _note, paymentSummarySections, paymentsSummaryLines, totalPayments, totalRefunds, _iterator8, _step8, _pm, _iterator11, _step11, _currency2, cashPm, _iterator9, _step9, currency, payments, refunds, change, receiptData, _DeviceModule$hardwar8;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                seller = UserModule.user;
                sellerName = "".concat(seller.firstName, " ").concat(seller.lastName);
                _context6.next = 4;
                return getGroupInfo();

              case 4:
                groupInfo = _context6.sent;
                paymentMethodSections = [];
                _iterator7 = _createForOfIteratorHelper(((_manualSummary$value7 = manualSummary.value) === null || _manualSummary$value7 === void 0 ? void 0 : _manualSummary$value7.amountsPerPaymentMethods) || []);
                _context6.prev = 7;

                _iterator7.s();

              case 9:
                if ((_step7 = _iterator7.n()).done) {
                  _context6.next = 58;
                  break;
                }

                pm = _step7.value;
                _iterator10 = _createForOfIteratorHelper(activeCurrencies.value);
                _context6.prev = 12;

                _iterator10.s();

              case 14:
                if ((_step10 = _iterator10.n()).done) {
                  _context6.next = 48;
                  break;
                }

                _currency = _step10.value;

                if (!(pm.name !== PaymentMethods.METHOD_POS_CASH && _currency !== groupCurrency.value)) {
                  _context6.next = 18;
                  break;
                }

                return _context6.abrupt("continue", 46);

              case 18:
                section = {
                  title: t("payment-method-in-currency", {
                    method: t("payment-method.".concat(pm.name)),
                    currency: _currency
                  }),
                  lines: []
                }; // special case for cash with main currency

                if (!(pm.name === PaymentMethods.METHOD_POS_CASH && _currency === groupCurrency.value)) {
                  _context6.next = 34;
                  break;
                }

                section.lines.push({
                  label: t("cashfloat.payments"),
                  value: (getCustomerAmountIn(pm, _currency) / 100).toFixed(2),
                  currency: _currency
                });
                section.lines.push({
                  label: t("cashfloat.refunds"),
                  value: (getRefund(pm, _currency) / 100).toFixed(2),
                  currency: _currency
                });
                section.lines.push({
                  label: t("cashfloat.change"),
                  value: (getChange(pm, _currency) / 100).toFixed(2),
                  currency: _currency
                });
                section.lines.push({
                  label: t("cashfloat.settlement"),
                  value: (getSettlement(pm, _currency) / 100).toFixed(2),
                  currency: _currency,
                  isBold: true,
                  hasBorder: true
                });
                section.lines.push({
                  label: t("cashfloat.initial-amount"),
                  value: (getInitialAmount(pm, _currency) / 100).toFixed(2),
                  currency: _currency,
                  marginTop: true
                });
                section.lines.push({
                  label: t("cashfloat.settlement"),
                  value: (getSettlement(pm, _currency) / 100).toFixed(2),
                  currency: _currency
                });

                if (hasLocation.value) {
                  section.lines.push({
                    label: t("cashfloat.transfer-in"),
                    value: (getTransferIn(pm, _currency) / 100).toFixed(2),
                    currency: _currency
                  });
                  section.lines.push({
                    label: t("cashfloat.transfer-out"),
                    value: (getTransferOut(pm, _currency) / 100).toFixed(2),
                    currency: _currency
                  });
                }

                section.lines.push({
                  label: t("cashfloat.expected-amount"),
                  value: (getExpectedAmount(pm, _currency) / 100).toFixed(2),
                  currency: _currency,
                  isBold: true,
                  marginTop: true
                });
                section.lines.push({
                  label: t("cashfloat.counted-amount"),
                  value: (getCountedAmount(pm, _currency) / 100).toFixed(2),
                  currency: _currency,
                  isBold: true
                });
                section.lines.push({
                  label: t("cashfloat.difference"),
                  value: (getDifference(pm, _currency) / 100).toFixed(2),
                  currency: _currency,
                  isBold: true,
                  hasBorder: true
                });
                _note2 = getNote(pm, _currency);

                if (_note2) {
                  section.lines.push({
                    label: t("cashfloat.note"),
                    value: _note2,
                    currency: ""
                  });
                }

                paymentMethodSections.push(section);
                return _context6.abrupt("continue", 46);

              case 34:
                section.lines.push({
                  label: t("cashfloat.initial-amount"),
                  value: (getInitialAmount(pm, _currency) / 100).toFixed(2),
                  currency: _currency
                });
                section.lines.push({
                  label: t("cashfloat.payments"),
                  value: (getCustomerAmountIn(pm, _currency) / 100).toFixed(2),
                  currency: _currency
                });
                section.lines.push({
                  label: t("cashfloat.refunds"),
                  value: (getRefund(pm, _currency) / 100).toFixed(2),
                  currency: _currency
                });
                section.lines.push({
                  label: t("cashfloat.change"),
                  value: (getChange(pm, _currency) / 100).toFixed(2),
                  currency: _currency
                });
                section.lines.push({
                  label: t("cashfloat.settlement"),
                  value: (getSettlement(pm, _currency) / 100).toFixed(2),
                  currency: _currency
                });

                if (hasLocation.value) {
                  section.lines.push({
                    label: t("cashfloat.transfer-in"),
                    value: (getTransferIn(pm, _currency) / 100).toFixed(2),
                    currency: _currency
                  });
                  section.lines.push({
                    label: t("cashfloat.transfer-out"),
                    value: (getTransferOut(pm, _currency) / 100).toFixed(2),
                    currency: _currency
                  });
                }

                section.lines.push({
                  label: t("cashfloat.expected-amount"),
                  value: (getExpectedAmount(pm, _currency) / 100).toFixed(2),
                  currency: _currency,
                  isBold: true
                });
                section.lines.push({
                  label: t("cashfloat.counted-amount"),
                  value: (getCountedAmount(pm, _currency) / 100).toFixed(2),
                  currency: _currency,
                  isBold: true
                });
                section.lines.push({
                  label: t("cashfloat.difference"),
                  value: (getDifference(pm, _currency) / 100).toFixed(2),
                  currency: _currency,
                  isBold: true,
                  hasBorder: true
                });
                _note = getNote(pm, _currency);

                if (_note) {
                  section.lines.push({
                    label: t("cashfloat.note"),
                    value: _note,
                    currency: ""
                  });
                }

                paymentMethodSections.push(section);

              case 46:
                _context6.next = 14;
                break;

              case 48:
                _context6.next = 53;
                break;

              case 50:
                _context6.prev = 50;
                _context6.t0 = _context6["catch"](12);

                _iterator10.e(_context6.t0);

              case 53:
                _context6.prev = 53;

                _iterator10.f();

                return _context6.finish(53);

              case 56:
                _context6.next = 9;
                break;

              case 58:
                _context6.next = 63;
                break;

              case 60:
                _context6.prev = 60;
                _context6.t1 = _context6["catch"](7);

                _iterator7.e(_context6.t1);

              case 63:
                _context6.prev = 63;

                _iterator7.f();

                return _context6.finish(63);

              case 66:
                paymentSummarySections = [];
                paymentsSummaryLines = [];
                totalPayments = 0;
                totalRefunds = 0; // Main currency first

                _iterator8 = _createForOfIteratorHelper(((_manualSummary$value8 = manualSummary.value) === null || _manualSummary$value8 === void 0 ? void 0 : _manualSummary$value8.amountsPerPaymentMethods) || []);
                _context6.prev = 71;

                _iterator8.s();

              case 73:
                if ((_step8 = _iterator8.n()).done) {
                  _context6.next = 97;
                  break;
                }

                _pm = _step8.value;
                _iterator11 = _createForOfIteratorHelper(activeCurrencies.value);
                _context6.prev = 76;

                _iterator11.s();

              case 78:
                if ((_step11 = _iterator11.n()).done) {
                  _context6.next = 87;
                  break;
                }

                _currency2 = _step11.value;

                if (!(_currency2 !== groupCurrency.value)) {
                  _context6.next = 82;
                  break;
                }

                return _context6.abrupt("continue", 85);

              case 82:
                totalPayments += getCustomerAmountIn(_pm, _currency2);
                totalRefunds += getRefund(_pm, _currency2);
                paymentsSummaryLines.push({
                  label: t("payment-method.".concat(_pm.name)),
                  columns: [{
                    value: (getCustomerAmountIn(_pm, _currency2) / 100).toFixed(2)
                  }, {
                    value: (getRefund(_pm, _currency2) / 100).toFixed(2)
                  }, {
                    value: "0.00"
                  }]
                });

              case 85:
                _context6.next = 78;
                break;

              case 87:
                _context6.next = 92;
                break;

              case 89:
                _context6.prev = 89;
                _context6.t2 = _context6["catch"](76);

                _iterator11.e(_context6.t2);

              case 92:
                _context6.prev = 92;

                _iterator11.f();

                return _context6.finish(92);

              case 95:
                _context6.next = 73;
                break;

              case 97:
                _context6.next = 102;
                break;

              case 99:
                _context6.prev = 99;
                _context6.t3 = _context6["catch"](71);

                _iterator8.e(_context6.t3);

              case 102:
                _context6.prev = 102;

                _iterator8.f();

                return _context6.finish(102);

              case 105:
                // Add digital payment methods
                if (digitalSummary.value) {
                  totalPayments += digitalSummary.value.totalCreditCard.payment + digitalSummary.value.totalGiftCard.payment;
                  totalRefunds += digitalSummary.value.totalCreditCard.refund + digitalSummary.value.totalGiftCard.refund;
                  paymentsSummaryLines.push({
                    label: t("cashfloat.credit_card"),
                    columns: [{
                      value: (digitalSummary.value.totalCreditCard.payment / 100).toFixed(2)
                    }, {
                      value: (digitalSummary.value.totalCreditCard.refund / 100).toFixed(2)
                    }, {
                      value: "0.00"
                    }]
                  });
                  paymentsSummaryLines.push({
                    label: t("cashfloat.gift-cards"),
                    columns: [{
                      value: (digitalSummary.value.totalGiftCard.payment / 100).toFixed(2)
                    }, {
                      value: (digitalSummary.value.totalGiftCard.refund / 100).toFixed(2)
                    }, {
                      value: "0.00"
                    }]
                  });
                }

                paymentSummarySections.push({
                  headers: ["".concat(t("currency"), ": ").concat(groupCurrency.value)],
                  lines: paymentsSummaryLines
                }); // Cash summary (Multi currency)

                cashPm = (_manualSummary$value5 = manualSummary.value) === null || _manualSummary$value5 === void 0 ? void 0 : _manualSummary$value5.amountsPerPaymentMethods.find(function (pm) {
                  return pm.name === PaymentMethods.METHOD_POS_CASH;
                });

                if (!cashPm) {
                  _context6.next = 130;
                  break;
                }

                _iterator9 = _createForOfIteratorHelper(activeCurrencies.value);
                _context6.prev = 110;

                _iterator9.s();

              case 112:
                if ((_step9 = _iterator9.n()).done) {
                  _context6.next = 122;
                  break;
                }

                currency = _step9.value;

                if (!(currency === groupCurrency.value)) {
                  _context6.next = 116;
                  break;
                }

                return _context6.abrupt("continue", 120);

              case 116:
                payments = getCustomerAmountIn(cashPm, currency);
                refunds = getRefund(cashPm, currency);
                change = getChange(cashPm, currency);
                paymentSummarySections.push({
                  headers: ["".concat(t("currency"), ": ").concat(currency)],
                  lines: [{
                    label: t("payment-method.CASH"),
                    columns: [{
                      value: (payments / 100).toFixed(2)
                    }, {
                      value: (refunds / 100).toFixed(2)
                    }, {
                      value: (change / 100).toFixed(2)
                    }]
                  }]
                });

              case 120:
                _context6.next = 112;
                break;

              case 122:
                _context6.next = 127;
                break;

              case 124:
                _context6.prev = 124;
                _context6.t4 = _context6["catch"](110);

                _iterator9.e(_context6.t4);

              case 127:
                _context6.prev = 127;

                _iterator9.f();

                return _context6.finish(127);

              case 130:
                receiptData = {
                  cashfloatUid: {
                    key: t("receipt.cash-float-id"),
                    value: cashfloat.uid
                  },
                  businessId: {
                    key: t("field.vat"),
                    value: groupInfo.vatNumber || groupInfo.registrationNum
                  },
                  openingDate: {
                    key: t("receipt.opening-date"),
                    value: formatDateTime(((_manualSummary$value6 = manualSummary.value) === null || _manualSummary$value6 === void 0 ? void 0 : _manualSummary$value6.createdAt) || "")
                  },
                  closingDate: {
                    key: t("receipt.closing-date"),
                    value: formatDateTime(cashfloat.closeDate || "")
                  },
                  groupInfo: groupInfo,
                  printDate: {
                    key: t("receipt.printed-on"),
                    value: formatDateTime(dayjs().toString())
                  },
                  openendBy: {
                    key: t("session.opened"),
                    value: openedByName.value
                  },
                  closedBy: {
                    key: t("session.closed"),
                    value: sellerName
                  },
                  paymentSummary: {
                    title: t("cashfloat.payments-summary"),
                    headers: [t("receipt.method"), t("receipt.payments"), t("receipt.refunds"), t("receipt.change")],
                    sections: paymentSummarySections
                  },
                  paymentMethodSections: paymentMethodSections,
                  closureDetailsField: t("cashfloat.closure-details"),
                  reconciliationOverviewField: t("cashfloat.reconciliation-overview"),
                  salesDetailsField: t("cashfloat.reconciliation-details")
                };

                if (hasLocation.value) {
                  receiptData.device = {
                    key: t("settings.device"),
                    value: ((_DeviceModule$hardwar8 = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar8 === void 0 ? void 0 : _DeviceModule$hardwar8.deviceName) || "NA"
                  };
                }

                LogService.info("Sale closure: Closing summary receipt data prepared for uuid: ".concat(cashfloat.uid), {
                  receiptData: receiptData
                });
                printClosingSummaryReceipt(receiptData);
                NotificationService.showCustomMessage(t("completeorder.print-receipts-success"), "success");

              case 135:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[7, 60, 63, 66], [12, 50, 53, 56], [71, 99, 102, 105], [76, 89, 92, 95], [110, 124, 127, 130]]);
      }));
      return _prepareAndPrintReceipt.apply(this, arguments);
    }

    function handleFocus(event) {
      var input = event.target;
      input.select();
    }

    function onCountedAmountBlur(paymentMethod, currency) {
      var raw = forMattedCountedAmounts.value[paymentMethod.name][currency];
      var parsed = parseFloat(raw.replace(",", "."));

      if (paymentMethod.countedAmounts === undefined) {
        paymentMethod.countedAmounts = {};
      }

      if (isNaN(parsed)) {
        forMattedCountedAmounts.value[paymentMethod.name][currency] = "0.00";
        paymentMethod.countedAmounts[currency] = 0;
        return;
      }

      var formatted = parsed.toFixed(2);
      forMattedCountedAmounts.value[paymentMethod.name][currency] = formatted;
      paymentMethod.countedAmounts[currency] = Math.round(parsed * 100);
    }

    function incrementAmount(paymentMethodSummary, currency) {
      var _paymentMethodSummary13;

      if (!paymentMethodSummary.countedAmounts) {
        paymentMethodSummary.countedAmounts = {};
      }

      var current = ((_paymentMethodSummary13 = paymentMethodSummary.countedAmounts) === null || _paymentMethodSummary13 === void 0 ? void 0 : _paymentMethodSummary13[currency]) || 0;
      paymentMethodSummary.countedAmounts[currency] = current + 100;
      forMattedCountedAmounts.value[paymentMethodSummary.name][currency] = ((current + 100) / 100).toFixed(2);
    }

    function decrementAmount(paymentMethodSummary, currency) {
      var _paymentMethodSummary14;

      if (!paymentMethodSummary.countedAmounts) {
        paymentMethodSummary.countedAmounts = {};
      }

      var current = ((_paymentMethodSummary14 = paymentMethodSummary.countedAmounts) === null || _paymentMethodSummary14 === void 0 ? void 0 : _paymentMethodSummary14[currency]) || 0;
      paymentMethodSummary.countedAmounts[currency] = Math.max(current - 100, 0);
      forMattedCountedAmounts.value[paymentMethodSummary.name][currency] = ((current - 100) / 100).toFixed(2);
    } // Open details view for a specific currency and payment method


    function viewDetails(paymentMethodSummary, currency) {
      selectedPayment.value = paymentMethodSummary;
      selectedCurrency.value = currency;
    }

    function getCurrencyIcon(currency) {
      switch (currency) {
        case "EUR":
          return EURIcon;

        case "CHF":
          return CHFIcon;

        case "USD":
          return USDIcon;

        case "GBP":
          return GBPIcon;

        default:
          return "";
      }
    }

    function handleInputFocus(event) {
      if (event.target.value === "0") {
        event.target.value = "";
      }
    }

    function handleInputBlur(event) {
      if (event.target.value === "") {
        event.target.value = "0";
      }
    }

    return function (_ctx, _cache) {
      var _manualSummary$value3, _manualSummary$value4;

      var _component_SyncInProgress = _resolveComponent("SyncInProgress");

      var _component_SvgIcon = _resolveComponent("SvgIcon");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_dialog = _resolveComponent("el-dialog");

      var _component_el_checkbox = _resolveComponent("el-checkbox");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [showSyncModal.value ? (_openBlock(), _createBlock(_component_SyncInProgress, {
        key: 0,
        onSyncSuccess: handleSyncSuccess
      })) : _createCommentVNode("", true), _createElementVNode("main", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t("cashfloat.sale-closure")), 1), _createElementVNode("button", {
        class: "watch-video-btn",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return toggleYoutubeDemoModal(true);
        })
      }, [_hoisted_7, _createVNode(_component_SvgIcon, {
        iconContent: _unref(YoutubeIcon),
        iconAlt: "info",
        iconStyle: "width: 20px; height: 20px;",
        class: "info-icon"
      }, null, 8, ["iconContent"])])]), _createElementVNode("p", _hoisted_8, _toDisplayString(sessionOpenedMessagee.value), 1)]), _createElementVNode("div", _hoisted_9, [hasLocation.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "btn btn-outline",
        onClick: addCashTransfer,
        "data-cy": "add-cash-transfer-button"
      }, [_hoisted_10, _createTextVNode(" " + _toDisplayString(_ctx.$t("cashfloat.cash-transfer")), 1)])) : _createCommentVNode("", true), _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: openCashDrawer,
        "data-cy": "open-cash-drawer-button"
      }, [_hoisted_11, _createTextVNode(" " + _toDisplayString(_ctx.$t("button.open-drawer")), 1)])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("button", {
        class: _normalizeClass(['tab-button', {
          active: activeTab.value === 'manual'
        }]),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return switchTab('manual');
        }),
        "data-cy": "manual-methods-button"
      }, _toDisplayString(_ctx.$t("cashfloat.manual-methods")), 3), _createElementVNode("button", {
        class: _normalizeClass(['tab-button', {
          active: activeTab.value === 'digital'
        }]),
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return switchTab('digital');
        }),
        "data-cy": "digital-methods-button"
      }, _toDisplayString(_ctx.$t("cashfloat.digital-methods")), 3)]), isLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("common.loading")) + "...", 1)])) : _createCommentVNode("", true), !isLoading.value && activeTab.value === 'manual' && (_manualSummary$value3 = manualSummary.value) !== null && _manualSummary$value3 !== void 0 && _manualSummary$value3.amountsPerPaymentMethods.length ? (_openBlock(), _createElementBlock("div", _hoisted_14, [selectedPayment.value && selectedCurrency.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["cash-details-panel", "details-panel-".concat(selectedPayment.value.name)]),
        "data-cy": "payment-method-details-panel"
      }, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createTextVNode(" " + _toDisplayString(_ctx.$t("payment-method-in-currency", {
        method: _ctx.$t("payment-method.".concat(selectedPayment.value.name)),
        currency: selectedCurrency.value
      })), 1)]), _createElementVNode("button", {
        class: "btn btn-outline btn-white btn-small font-weight-700",
        "data-cy": "cash-inventory-button",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return openCashInventory(selectedCurrency.value);
        })
      }, [_hoisted_18, _createTextVNode(" " + _toDisplayString(_ctx.$t("cashfloat.cash-inventory")), 1)])]), selectedPayment.value.name === _unref(PaymentMethods).METHOD_POS_CASH && selectedCurrency.value === groupCurrency.value ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)("cashfloat.payments")), 1), _createElementVNode("span", _hoisted_22, _toDisplayString(formatCurrencyWithSymbol(getCustomerAmountIn(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)("cashfloat.refunds")), 1), _createElementVNode("span", _hoisted_25, _toDisplayString(formatCurrencyWithSymbol(getRefund(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(_unref(t)("cashfloat.change")), 1), _createElementVNode("span", _hoisted_28, _toDisplayString(formatCurrencyWithSymbol(getChange(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)("cashfloat.settlement")), 1), _createElementVNode("span", _hoisted_31, _toDisplayString(formatCurrencyWithSymbol(getSettlement(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), _createElementVNode("div", _hoisted_32, [_createElementVNode("span", _hoisted_33, _toDisplayString(_unref(t)("cashfloat.initial-amount")), 1), _createElementVNode("span", _hoisted_34, _toDisplayString(formatCurrencyWithSymbol(getInitialAmount(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), _createElementVNode("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString(_unref(t)("cashfloat.settlement")), 1), _createElementVNode("span", _hoisted_37, _toDisplayString(formatCurrencyWithSymbol(getSettlement(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), hasLocation.value && selectedPayment.value.name === _unref(PaymentMethods).METHOD_POS_CASH ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("span", _hoisted_39, _toDisplayString(_unref(t)("cashfloat.transfer-in")), 1), _createElementVNode("span", _hoisted_40, _toDisplayString(formatCurrencyWithSymbol(getTransferIn(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)])) : _createCommentVNode("", true), hasLocation.value && selectedPayment.value.name === _unref(PaymentMethods).METHOD_POS_CASH ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("span", _hoisted_42, _toDisplayString(_unref(t)("cashfloat.transfer-out")), 1), _createElementVNode("span", _hoisted_43, _toDisplayString(formatCurrencyWithSymbol(getTransferOut(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_44, [_createElementVNode("span", _hoisted_45, _toDisplayString(_unref(t)("cashfloat.expected-amount")), 1), _createElementVNode("span", _hoisted_46, _toDisplayString(formatCurrencyWithSymbol(getExpectedAmount(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), _createElementVNode("div", _hoisted_47, [_createElementVNode("span", _hoisted_48, _toDisplayString(_unref(t)("cashfloat.counted-amount")), 1), _createElementVNode("span", _hoisted_49, _toDisplayString(formatCurrencyWithSymbol(getCountedAmount(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), _createElementVNode("div", _hoisted_50, [_createElementVNode("span", {
        class: _normalizeClass(["detail-value", !getDifference(selectedPayment.value, selectedCurrency.value) ? 'green' : 'red'])
      }, _toDisplayString(_unref(t)("cashfloat.difference")), 3), _createElementVNode("span", {
        class: _normalizeClass(["detail-value", 'difference-amount', !getDifference(selectedPayment.value, selectedCurrency.value) ? 'green' : 'red'])
      }, _toDisplayString(formatCurrencyWithSymbol(getDifference(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 3)]), _createElementVNode("div", _hoisted_51, [_createElementVNode("span", _hoisted_52, _toDisplayString(_unref(t)("cashfloat.note")), 1), _createElementVNode("span", _hoisted_53, _toDisplayString(!getNote(selectedPayment.value, selectedCurrency.value) ? "-" : getNote(selectedPayment.value, selectedCurrency.value)), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createElementVNode("span", _hoisted_56, _toDisplayString(_unref(t)("cashfloat.initial-amount")), 1), _createElementVNode("span", _hoisted_57, _toDisplayString(formatCurrencyWithSymbol(getInitialAmount(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), _createElementVNode("div", _hoisted_58, [_createElementVNode("span", _hoisted_59, _toDisplayString(_unref(t)("cashfloat.payments")), 1), _createElementVNode("span", _hoisted_60, _toDisplayString(formatCurrencyWithSymbol(getCustomerAmountIn(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), _createElementVNode("div", _hoisted_61, [_createElementVNode("span", _hoisted_62, _toDisplayString(_unref(t)("cashfloat.refunds")), 1), _createElementVNode("span", _hoisted_63, _toDisplayString(formatCurrencyWithSymbol(getRefund(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), _createElementVNode("div", _hoisted_64, [_createElementVNode("span", _hoisted_65, _toDisplayString(_unref(t)("cashfloat.change")), 1), _createElementVNode("span", _hoisted_66, _toDisplayString(formatCurrencyWithSymbol(getChange(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), _createElementVNode("div", _hoisted_67, [_createElementVNode("span", _hoisted_68, _toDisplayString(_unref(t)("cashfloat.settlement")), 1), _createElementVNode("span", _hoisted_69, _toDisplayString(formatCurrencyWithSymbol(getSettlement(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), hasLocation.value && selectedPayment.value.name === _unref(PaymentMethods).METHOD_POS_CASH ? (_openBlock(), _createElementBlock("div", _hoisted_70, [_createElementVNode("span", _hoisted_71, _toDisplayString(_unref(t)("cashfloat.transfer-in")), 1), _createElementVNode("span", _hoisted_72, _toDisplayString(formatCurrencyWithSymbol(getTransferIn(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)])) : _createCommentVNode("", true), hasLocation.value && selectedPayment.value.name === _unref(PaymentMethods).METHOD_POS_CASH ? (_openBlock(), _createElementBlock("div", _hoisted_73, [_createElementVNode("span", _hoisted_74, _toDisplayString(_unref(t)("cashfloat.transfer-out")), 1), _createElementVNode("span", _hoisted_75, _toDisplayString(formatCurrencyWithSymbol(getTransferOut(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_76, [_createElementVNode("span", _hoisted_77, _toDisplayString(_unref(t)("cashfloat.expected-amount")), 1), _createElementVNode("span", _hoisted_78, _toDisplayString(formatCurrencyWithSymbol(getExpectedAmount(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), _createElementVNode("div", _hoisted_79, [_createElementVNode("span", _hoisted_80, _toDisplayString(_unref(t)("cashfloat.counted-amount")), 1), _createElementVNode("span", _hoisted_81, _toDisplayString(formatCurrencyWithSymbol(getCountedAmount(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 1)]), _createElementVNode("div", _hoisted_82, [_createElementVNode("span", {
        class: _normalizeClass(["detail-value", !getDifference(selectedPayment.value, selectedCurrency.value) ? 'green' : 'red'])
      }, _toDisplayString(_unref(t)("cashfloat.difference")), 3), _createElementVNode("span", {
        class: _normalizeClass(["detail-value", 'difference-amount', !getDifference(selectedPayment.value, selectedCurrency.value) ? 'green' : 'red'])
      }, _toDisplayString(formatCurrencyWithSymbol(getDifference(selectedPayment.value, selectedCurrency.value), selectedCurrency.value)), 3)]), _createElementVNode("div", _hoisted_83, [_createElementVNode("span", _hoisted_84, _toDisplayString(_unref(t)("cashfloat.note")), 1), _createElementVNode("span", _hoisted_85, _toDisplayString(!getNote(selectedPayment.value, selectedCurrency.value) ? "-" : getNote(selectedPayment.value, selectedCurrency.value)), 1)])]))], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "cash-panel",
        ref_key: "currencyPanels",
        ref: currencyPanels
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_manualSummary$value4 = manualSummary.value) === null || _manualSummary$value4 === void 0 ? void 0 : _manualSummary$value4.amountsPerPaymentMethods, function (paymentMethod) {
        return _openBlock(), _createElementBlock("div", {
          key: paymentMethod.name,
          class: _normalizeClass(["mb-10 summary-panel", "summary-panel-".concat(paymentMethod.name)])
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeCurrencies.value, function (currency) {
          var _selectedPayment$valu, _selectedPayment$valu2;

          return _openBlock(), _createElementBlock("div", {
            key: currency
          }, [paymentMethod.name === _unref(PaymentMethods).METHOD_POS_CASH || currency === groupCurrency.value ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["currency-section", "currency-section-".concat(currency)]),
            id: "currency-section-".concat(paymentMethod.name, "-").concat(currency)
          }, [_createElementVNode("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_createVNode(_component_SvgIcon, {
            iconContent: getCurrencyIcon(currency),
            iconAlt: "info",
            iconStyle: "width: 20px; height: 20px;",
            class: "info-icon"
          }, null, 8, ["iconContent"]), _createTextVNode(" " + _toDisplayString(_ctx.$t("payment-method-in-currency", {
            method: _ctx.$t("payment-method.".concat(paymentMethod.name)),
            currency: currency
          })), 1)]), _createElementVNode("span", {
            class: _normalizeClass("status-badge ".concat(!getDifference(paymentMethod, currency) ? 'matched' : 'unmatched'))
          }, _toDisplayString(!getDifference(paymentMethod, currency) ? _ctx.$t("cashfloat.match") : _ctx.$t("cashfloat.mismatch")), 3)]), _createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, _toDisplayString(_unref(t)("cashfloat.initial-amount")), 1), _createElementVNode("div", _hoisted_93, _toDisplayString(formatCurrencyWithSymbol(getInitialAmount(paymentMethod, currency), currency)), 1)]), _createElementVNode("div", _hoisted_94, [_createElementVNode("div", _hoisted_95, _toDisplayString(_unref(t)("cashfloat.difference")), 1), _createElementVNode("div", {
            class: _normalizeClass(['currency-value', !getDifference(paymentMethod, currency) ? '' : 'red'])
          }, _toDisplayString(formatCurrencyWithSymbol(getDifference(paymentMethod, currency), currency)), 3)])]), _createElementVNode("div", _hoisted_96, [_createElementVNode("div", _hoisted_97, _toDisplayString(_unref(t)("cashfloat.counted-amount")), 1)]), _createElementVNode("div", _hoisted_98, [_withDirectives(_createElementVNode("input", {
            type: "text",
            class: "amount-input",
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return forMattedCountedAmounts.value[paymentMethod.name][currency] = $event;
            },
            onBlur: function onBlur($event) {
              return onCountedAmountBlur(paymentMethod, currency);
            },
            onFocus: handleFocus
          }, null, 40, _hoisted_99), [[_vModelText, forMattedCountedAmounts.value[paymentMethod.name][currency]]]), _createElementVNode("div", _hoisted_100, [_createElementVNode("button", {
            class: "arrow-up",
            onClick: function onClick($event) {
              return incrementAmount(paymentMethod, currency);
            }
          }, _hoisted_103, 8, _hoisted_101), _createElementVNode("button", {
            class: "arrow-down",
            onClick: function onClick($event) {
              return decrementAmount(paymentMethod, currency);
            }
          }, _hoisted_106, 8, _hoisted_104)])]), _createElementVNode("div", _hoisted_107, [_createElementVNode("button", {
            class: _normalizeClass(['btn btn-outline btn-full btn-white', paymentMethod.name === ((_selectedPayment$valu = selectedPayment.value) === null || _selectedPayment$valu === void 0 ? void 0 : _selectedPayment$valu.name) && currency === selectedCurrency.value ? 'btn-selected' : '']),
            onClick: function onClick($event) {
              return viewDetails(paymentMethod, currency);
            },
            "data-cy": "view-details-button"
          }, [paymentMethod.name === ((_selectedPayment$valu2 = selectedPayment.value) === null || _selectedPayment$valu2 === void 0 ? void 0 : _selectedPayment$valu2.name) && currency === selectedCurrency.value ? (_openBlock(), _createElementBlock("img", _hoisted_109)) : (_openBlock(), _createElementBlock("img", _hoisted_110)), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.view-details")), 1)], 10, _hoisted_108), _createElementVNode("button", {
            class: _normalizeClass(['btn btn-outline btn-full btn-white', getDifference(paymentMethod, currency) && !getNote(paymentMethod, currency) ? 'btn-error' : '']),
            onClick: function onClick($event) {
              return openNoteDialog(paymentMethod, currency);
            },
            "data-cy": "add-note-button"
          }, [_createElementVNode("span", {
            id: "note-content-".concat(paymentMethod.name, "-").concat(currency),
            class: "note-content"
          }, [getDifference(paymentMethod, currency) && !getNote(paymentMethod, currency) ? (_openBlock(), _createElementBlock("img", _hoisted_113)) : (_openBlock(), _createElementBlock("img", _hoisted_114)), _createTextVNode(" " + _toDisplayString(_ctx.$t("cashfloat.add-note")), 1)], 8, _hoisted_112)], 10, _hoisted_111)])])], 10, _hoisted_86)) : _createCommentVNode("", true)]);
        }), 128))], 2);
      }), 128))], 512)])) : _createCommentVNode("", true), !isLoading.value && activeTab.value === 'digital' ? (_openBlock(), _createElementBlock("div", _hoisted_115, [_createElementVNode("div", _hoisted_116, [_createElementVNode("div", _hoisted_117, _toDisplayString(_ctx.$t("cashfloat.digital-methods-summary")), 1)]), digitalSummary.value ? (_openBlock(), _createElementBlock("div", _hoisted_118, [_createElementVNode("div", _hoisted_119, [_createElementVNode("p", _hoisted_120, _toDisplayString(_unref(t)("cashfloat.payment-methods")), 1), _createElementVNode("div", _hoisted_121, [_createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.$t("cashfloat.payments")), 1), _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.$t("cashfloat.refunds")), 1), _createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.$t("cashfloat.settlement")), 1)])]), _createElementVNode("div", _hoisted_125, [_createElementVNode("p", _hoisted_126, _toDisplayString(_unref(t)("cashfloat.credit-cards")), 1), _createElementVNode("div", _hoisted_127, [_createElementVNode("span", _hoisted_128, _toDisplayString(formatCurrencyWithSymbol(digitalSummary.value.totalCreditCard.payment, groupCurrency.value)), 1), _createElementVNode("span", _hoisted_129, _toDisplayString(formatCurrencyWithSymbol(digitalSummary.value.totalCreditCard.refund, groupCurrency.value)), 1), _createElementVNode("span", _hoisted_130, _toDisplayString(formatCurrencyWithSymbol(digitalSummary.value.totalCreditCard.payment + digitalSummary.value.totalCreditCard.refund, groupCurrency.value)), 1)])]), _createElementVNode("div", _hoisted_131, [_createElementVNode("p", _hoisted_132, _toDisplayString(_unref(t)("cashfloat.vouchers")), 1), _createElementVNode("div", _hoisted_133, [_createElementVNode("span", _hoisted_134, _toDisplayString(formatCurrencyWithSymbol(digitalSummary.value.totalVoucher.payment, groupCurrency.value)), 1), _createElementVNode("span", _hoisted_135, _toDisplayString(formatCurrencyWithSymbol(digitalSummary.value.totalVoucher.refund, groupCurrency.value)), 1), _createElementVNode("span", _hoisted_136, _toDisplayString(formatCurrencyWithSymbol(digitalSummary.value.totalVoucher.payment + digitalSummary.value.totalVoucher.refund, groupCurrency.value)), 1)])]), _createElementVNode("div", _hoisted_137, [_createElementVNode("p", _hoisted_138, _toDisplayString(_unref(t)("cashfloat.gift-cards")), 1), _createElementVNode("div", _hoisted_139, [_createElementVNode("span", _hoisted_140, _toDisplayString(formatCurrencyWithSymbol(digitalSummary.value.totalGiftCard.payment, groupCurrency.value)), 1), _createElementVNode("span", _hoisted_141, _toDisplayString(formatCurrencyWithSymbol(digitalSummary.value.totalGiftCard.refund, groupCurrency.value)), 1), _createElementVNode("span", _hoisted_142, _toDisplayString(formatCurrencyWithSymbol(digitalSummary.value.totalGiftCard.payment + digitalSummary.value.totalGiftCard.refund, groupCurrency.value)), 1)])]), _createElementVNode("div", _hoisted_143, [_createElementVNode("p", _hoisted_144, _toDisplayString(_unref(t)("field.total")), 1), _createElementVNode("div", _hoisted_145, [_createElementVNode("span", _hoisted_146, _toDisplayString(formatCurrencyWithSymbol(digitalSummary.value.total.payment, groupCurrency.value)), 1), _createElementVNode("span", _hoisted_147, _toDisplayString(formatCurrencyWithSymbol(digitalSummary.value.total.refund, groupCurrency.value)), 1), _createElementVNode("span", _hoisted_148, _toDisplayString(formatCurrencyWithSymbol(digitalSummary.value.total.payment + digitalSummary.value.total.refund, groupCurrency.value)), 1)])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_149, [_createElementVNode("div", _hoisted_150, [_hoisted_151, _createElementVNode("p", null, _toDisplayString(_unref(t)("cashfloat.closure-warning-message")), 1)]), _createElementVNode("div", _hoisted_152, [_createElementVNode("button", {
        class: "btn btn-outline btn-large",
        onClick: cancelAndReturn,
        "data-cy": "cancel-button",
        disabled: isSubmitting.value || isLoading.value
      }, [_hoisted_154, _createTextVNode(" " + _toDisplayString(_unref(t)("cashfloat.cancel-return")), 1)], 8, _hoisted_153), _createElementVNode("button", {
        class: "btn btn-primary btn-large",
        onClick: acceptAndClose,
        "data-cy": "accept-button",
        disabled: isSubmitting.value || isLoading.value
      }, [_hoisted_156, _createTextVNode(" " + _toDisplayString(_unref(t)("cashfloat.accept-close")), 1)], 8, _hoisted_155)])]), showNoteDialog.value && selectedPaymentForNote.value && selectedCurrencyForNote.value ? (_openBlock(), _createElementBlock("div", _hoisted_157, [_createVNode(_component_el_dialog, {
        modelValue: showNoteDialog.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
          return showNoteDialog.value = $event;
        }),
        title: _unref(t)('cashfloat.add-note'),
        width: "30%"
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_158, [_createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = function ($event) {
              return showNoteDialog.value = false;
            }),
            "data-cy": "cancel-note-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(t)("button.cancel")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[6] || (_cache[6] = function ($event) {
              return addNote(selectedPaymentForNote.value, selectedCurrencyForNote.value);
            }),
            "data-cy": "confirm-note-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(t)("button.confirm")), 1)];
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", null, [_createVNode(_component_el_input, {
            modelValue: note.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return note.value = $event;
            }),
            rows: 3,
            type: "textarea",
            placeholder: _unref(t)('cashfloat.write-your-note-here'),
            "data-cy": "note-textarea"
          }, null, 8, ["modelValue", "placeholder"])])];
        }),
        _: 1
      }, 8, ["modelValue", "title"])])) : _createCommentVNode("", true), showCashInventoryDialog.value && selectedDetailedCurrency.value ? (_openBlock(), _createElementBlock("div", _hoisted_159, [_createVNode(_component_el_dialog, {
        width: "50%",
        modelValue: showCashInventoryDialog.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
          return showCashInventoryDialog.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_160, [_createElementVNode("div", {
            style: {
              "height": "54vh",
              "overflow-y": "scroll",
              "padding": "10px"
            },
            ref_key: "cashDetailsArea",
            ref: cashDetailsArea
          }, [_createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_161, _toDisplayString(_ctx.$t("payment-method-in-currency", {
            method: _ctx.$t("payment-method.CASH"),
            currency: selectedDetailedCurrency.value.label
          })), 1)]), _createElementVNode("div", _hoisted_162, [_createElementVNode("div", _hoisted_163, [_createElementVNode("div", _hoisted_164, [_createElementVNode("p", null, _toDisplayString(_unref(t)("cashfloat.bills")), 1)]), _createElementVNode("div", _hoisted_165, [_createElementVNode("p", null, _toDisplayString(_unref(t)("cashfloat.amount")), 1)]), _createElementVNode("div", _hoisted_166, [_createElementVNode("p", null, _toDisplayString(_unref(t)("cashfloat.value")), 1)])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedDetailedCurrency.value.bills, function (bill, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              style: {
                "display": "flex",
                "flex-direction": "row",
                "justify-content": "center",
                "align-items": "center",
                "border-bottom": "1px solid #ededed",
                "padding-bottom": "1%",
                "padding-top": "1%"
              }
            }, [_createElementVNode("div", _hoisted_167, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(bill.name), 1)])]), _createElementVNode("div", _hoisted_168, [_createVNode(_component_el_input, {
              modelValue: bill.userInput,
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return bill.userInput = $event;
              },
              type: "number",
              min: 0,
              onFocus: handleInputFocus,
              onBlur: handleInputBlur,
              "data-cy": "cash-bill-input-".concat(bill.name)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "data-cy"])]), _createElementVNode("div", _hoisted_169, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(selectedDetailedCurrency.value.symbol + " " + (Number(bill.name) * (bill.userInput || 0)).toLocaleString("en-EN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).split(",").join("'")), 1)])])]);
          }), 128))]), _hoisted_170, _createElementVNode("div", _hoisted_171, [_createElementVNode("div", _hoisted_172, [_createElementVNode("div", _hoisted_173, [_createElementVNode("p", null, _toDisplayString(_unref(t)("cashfloat.coins")), 1)]), _createElementVNode("div", _hoisted_174, [_createElementVNode("p", null, _toDisplayString(_unref(t)("cashfloat.amount")), 1)]), _createElementVNode("div", _hoisted_175, [_createElementVNode("p", null, _toDisplayString(_unref(t)("cashfloat.value")), 1)])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedDetailedCurrency.value.coins, function (coin, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              style: {
                "display": "flex",
                "flex-direction": "row",
                "justify-content": "center",
                "align-items": "center",
                "border-bottom": "1px solid #ededed",
                "padding-bottom": "1%",
                "padding-top": "1%"
              }
            }, [_createElementVNode("div", _hoisted_176, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(coin.name), 1)])]), _createElementVNode("div", _hoisted_177, [_createVNode(_component_el_input, {
              modelValue: coin.userInput,
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return coin.userInput = $event;
              },
              type: "number",
              min: 0,
              onFocus: handleInputFocus,
              onBlur: handleInputBlur,
              "data-cy": "cash-coin-input-".concat(coin.name)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "data-cy"])]), _createElementVNode("div", _hoisted_178, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(selectedDetailedCurrency.value.symbol + " " + (Number(coin.name) * (coin.userInput || 0)).toLocaleString("en-EN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).split(",").join("'")), 1)])])]);
          }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedDetailedCurrency.value.cents, function (cent, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              style: {
                "display": "flex",
                "flex-direction": "row",
                "justify-content": "center",
                "align-items": "center",
                "border-bottom": "1px solid #ededed",
                "padding-bottom": "1%",
                "padding-top": "1%"
              }
            }, [_createElementVNode("div", _hoisted_179, [_createElementVNode("p", null, [_createElementVNode("strong", null, [_createTextVNode(_toDisplayString(cent.name), 1), _createElementVNode("span", _hoisted_180, _toDisplayString(_unref(t)("cashfloat.cents")), 1)])])]), _createElementVNode("div", _hoisted_181, [_createVNode(_component_el_input, {
              modelValue: cent.userInput,
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return cent.userInput = $event;
              },
              type: "number",
              min: 0,
              onFocus: handleInputFocus,
              onBlur: handleInputBlur,
              "data-cy": "cash-cent-input-".concat(cent.name)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "data-cy"])]), _createElementVNode("div", _hoisted_182, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(selectedDetailedCurrency.value.symbol + " " + (Number(cent.name) * (cent.userInput || 0) / 100).toLocaleString("en-EN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).split(",").join("'")), 1)])])]);
          }), 128))]), _createElementVNode("div", _hoisted_183, [_createElementVNode("div", _hoisted_184, [_createElementVNode("p", _hoisted_185, _toDisplayString(_unref(t)("field.total")), 1)]), _createElementVNode("div", null, [_createElementVNode("p", _hoisted_186, _toDisplayString((sumDetailedCurrency(selectedDetailedCurrency.value) / 100).toLocaleString("en-EN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).split(",").join("'")), 1)])])])], 512), _createElementVNode("div", _hoisted_187, [false ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: scrollToTopCashInventory,
            style: {
              "height": "35px"
            },
            class: "green-plain",
            type: "primary"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("Scroll Top")];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            onClick: cancelCashInventory,
            style: {
              "height": "35px"
            },
            class: "green-plain",
            "data-cy": "cancel-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: confirmCashInventory,
            style: {
              "height": "35px"
            },
            class: "green-plain",
            type: "primary",
            "data-cy": "confirm-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
            }),
            _: 1
          })])])];
        }),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true), showCashDestinationModal.value ? (_openBlock(), _createElementBlock("div", _hoisted_188, [_createElementVNode("div", {
        class: "cdm-overlay",
        onClick: _withModifiers(closeCashDestinationModal, ["self"])
      }, [_createElementVNode("div", _hoisted_189, [_createElementVNode("div", _hoisted_190, [_createElementVNode("h3", _hoisted_191, _toDisplayString(_unref(t)("cashfloat.select-cash-destination")), 1)]), _createElementVNode("div", _hoisted_192, [_createElementVNode("div", _hoisted_193, [_createElementVNode("label", _hoisted_194, _toDisplayString(_unref(t)("cashfloat.cash-intended-to")), 1), _withDirectives(_createElementVNode("select", {
        id: "destination-select",
        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
          return selectedDestinationLocationId.value = $event;
        }),
        disabled: willMoneyStayInDrawer.value,
        class: "cdm-select",
        "data-cy": "cash-destination-select"
      }, [_createElementVNode("option", _hoisted_196, _toDisplayString(_unref(t)("cashfloat.choose-location")), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationsList.value, function (item) {
        return _openBlock(), _createElementBlock("option", {
          key: Number(item.id),
          value: Number(item.id),
          "data-cy": "cash-destination-option"
        }, _toDisplayString(String(item.name)), 9, _hoisted_197);
      }), 128))], 8, _hoisted_195), [[_vModelSelect, selectedDestinationLocationId.value]])]), _createElementVNode("div", _hoisted_198, [_createVNode(_component_el_checkbox, {
        modelValue: willMoneyStayInDrawer.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
          return willMoneyStayInDrawer.value = $event;
        }),
        label: _ctx.$t('cashfloat.money-stays-in-the-drawer'),
        size: "large",
        onChange: resetSelectedDestination
      }, null, 8, ["modelValue", "label"])])]), _createElementVNode("div", _hoisted_199, [_createVNode(_component_el_button, {
        onClick: closeCashDestinationModal,
        "data-cy": "close-destination-modal",
        disabled: isSubmitting.value
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref(t)("button.cancel")), 1)];
        }),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: acceptAndClose,
        disabled: isSubmitting.value || !willMoneyStayInDrawer.value && !selectedDestinationLocationId.value,
        "data-cy": "confirm-destination-button"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref(t)("button.confirm")), 1)];
        }),
        _: 1
      }, 8, ["disabled"])])])])])) : _createCommentVNode("", true), showYoutubeDemo.value ? (_openBlock(), _createElementBlock("div", _hoisted_200, [_createElementVNode("div", {
        class: "cdm-overlay",
        onClick: _cache[11] || (_cache[11] = _withModifiers(function ($event) {
          return toggleYoutubeDemoModal(false);
        }, ["self"]))
      }, _hoisted_202)])) : _createCommentVNode("", true)]);
    };
  }
});